// extracted by mini-css-extract-plugin
export default {"container":"Documentation_container__RLgui","content":"Documentation_content__dlfpP","documentBlock":"Documentation_documentBlock__wWmIg"};